// @flow
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';
import { Spacer } from 'statsradio/themes/v3/Stylesheet';
import type { ComparedMetric } from '../../../domain/DashboardData';
import SingleDayMetric from './SingleDayMetric';

const VerticalContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column; 
  justify-content: space-around;
  height: 100%;
`;

const SSpacer = styled(Spacer)`
  margin: ${props => props.theme.V3.metrics.margin.normal}px 0;
`;

interface Props {
  type: string,
  saturdayComparedMetric: ComparedMetric,
  sundayComparedMetric: ComparedMetric,

  t: any,
  theme: any,
}

function WeekendMetrics({ type, saturdayComparedMetric, sundayComparedMetric, t }: Props) {
  return (
    <VerticalContainer>
      <SingleDayMetric day={t('dayOfWeek.saturday')} metric={saturdayComparedMetric} type={type} />
      <SSpacer horizontal />
      <SingleDayMetric day={t('dayOfWeek.sunday')} metric={sundayComparedMetric} type={type} />
    </VerticalContainer>
  );
}

export default translate('dashboard')(withTheme(WeekendMetrics));



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/v2/components/audienceComparison/WeekendMetrics.js